"use client";

import { useEffect, useState } from "react";

/**
 * A payment identifier the other side has to reproduce exactly. Typing a UPI ID
 * or an IFSC by hand is how money ends up in a stranger's account, so the value
 * is always copyable rather than merely readable.
 */
export function CopyValue({ label, value }: { label: string; value: string }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 1600);
    return () => clearTimeout(timer);
  }, [copied]);

  return (
    <div className="flex items-baseline justify-between gap-3 text-sm">
      <dt className="shrink-0 text-ink-muted">{label}</dt>
      <dd className="min-w-0">
        <button
          type="button"
          onClick={() => {
            navigator.clipboard.writeText(value).then(
              () => setCopied(true),
              () => setCopied(false),
            );
          }}
          className="flex min-w-0 items-center gap-1.5 font-medium text-ink transition hover:text-brand-700"
          title="Copy"
        >
          <span className="truncate">{value}</span>
          <span
            aria-hidden="true"
            className="shrink-0 text-[10px] font-medium tracking-wide text-ink-subtle uppercase"
          >
            {copied ? "Copied" : "Copy"}
          </span>
        </button>
      </dd>
    </div>
  );
}
